function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import MobileTabNavButtonWithIcon from "segments/desktop/core-components/mobile-tabs/mobile-tab-nav-button-with-icon";
import BuildingBlocksTabsMobileComponent from "segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-mobile-component/building-blocks-tabs-mobile-component";
import { usecaseTabConvertor } from "/segments/desktop/tabs/layouts/usecases-gallery-tabs/util/usecase-tab-convertor";
import { StyledUsecasesGalleryTabsMobileComponent } from "/segments/desktop/tabs/layouts/usecases-gallery-tabs/usecases-gallery-tabs-mobile-component/usecases-gallery-tabs-mobile-component.scss";
// util function that calculates the defaultSelectedTabIndex
const getDefaultSelectedTabIndex = (tabs, defaultSelectedTabLabel)=>{
    const index = tabs.findIndex((tab)=>{
        var _tab_tabLabel;
        return ((_tab_tabLabel = tab.tabLabel) === null || _tab_tabLabel === void 0 ? void 0 : _tab_tabLabel.toLowerCase()) === (defaultSelectedTabLabel === null || defaultSelectedTabLabel === void 0 ? void 0 : defaultSelectedTabLabel.toLowerCase());
    });
    return index !== -1 ? index : 0;
};
const UsecasesGalleryTabsMobileComponent = (props)=>{
    const { usecases, selectedIconBackground, defaultSelectedTabLabel } = props;
    const tabs = usecases.map((usecase)=>usecaseTabConvertor(usecase));
    const customNavigationItemRenderer = (tab, index, isSelected = false)=>{
        return /*#__PURE__*/ _jsx(MobileTabNavButtonWithIcon, {
            label: tab.tabLabel,
            icon: tab.tabIcon,
            isSelected: isSelected,
            selectedIconBackgroundColor: selectedIconBackground
        }, index);
    };
    const defaultSelectedTabIndex = getDefaultSelectedTabIndex(tabs, defaultSelectedTabLabel);
    return /*#__PURE__*/ _jsx(StyledUsecasesGalleryTabsMobileComponent, {
        className: "usecases-gallery-tabs-mobile-component",
        children: /*#__PURE__*/ _jsx(BuildingBlocksTabsMobileComponent, _object_spread_props(_object_spread({}, props), {
            tabs: tabs,
            customNavigationItemRenderer: customNavigationItemRenderer,
            defaultSelectedTabIndex: defaultSelectedTabIndex
        }))
    });
};
export default UsecasesGalleryTabsMobileComponent;
